import {
  STATION_SERVICE_PRICE_TYPES,
  STATION_SERVICES_SORTING,
  ROUTE_STATION_SERVICES_FILTERS
} from './constants';

import {
  RouteStationServicesFilter,
  RouteStationServicesPrices,
  StationServicesSorting
} from './context/filter/types';

export const checkIsAllActiveFilter = (activeFilter: RouteStationServicesFilter) => (
  activeFilter === ROUTE_STATION_SERVICES_FILTERS.all
);

export const checkIsTop5ByCountryActiveFilter = (activeFilter: RouteStationServicesFilter) => (
  activeFilter === ROUTE_STATION_SERVICES_FILTERS.top5ByCountry
);

export const checkIsTopPriceEvery100kmActiveFilter = (activeFilter: RouteStationServicesFilter) => (
  activeFilter === ROUTE_STATION_SERVICES_FILTERS.topPriceEvery100km
);

export const checkIsRouteStationServicesPricesInEUR = (value: RouteStationServicesPrices) => (
  value === STATION_SERVICE_PRICE_TYPES.inEUR
);

export const checkIsRouteStationServicesPricesInCountry = (value: RouteStationServicesPrices) => (
  value === STATION_SERVICE_PRICE_TYPES.inCountry
);

export const checkIsActiveStationsServicesDefaultSorting = (value: StationServicesSorting) => (
  value === STATION_SERVICES_SORTING.default
);

export const checkIsActiveStationsServicesHightSorting = (value: StationServicesSorting) => (
  value === STATION_SERVICES_SORTING.hight
);

export const checkIsActiveStationsServicesLowSorting = (value: StationServicesSorting) => (
  value === STATION_SERVICES_SORTING.low
);
